import { affiliationSettingsEnabled } from '@/actions-permission/affiliations-settings.permissions'

export const routeAffiliationsCreated = (query, next) => {
  const { code, state: meta } = query

  if (!code || !meta) {
    return false
  }

  const [acquirer, merchantId, accountId, state] = meta.split('-')

  next({
    path: `/${merchantId}/${accountId}/settings/affiliations?code=${code}&state=${state}&acquirer=${acquirer}`
  })
  return true
}

const routeAffiliationsConfig = store => ({
  path: 'affiliations',
  name: 'affiliations',
  component: () => import('@/views/Settings/Affiliations/index.vue'),
  beforeEnter: (to, from, next) => {
    if (
      !affiliationSettingsEnabled(
        store.getters.permissionIsEnabled,
        store.getters.businessModel,
        store.getters.isTestAccount
      )
    ) {
      return store.commit('toggleGlobalError', { status: true, code: 404 })
    }

    next()
  },
  meta: {
    breadcrumb: {
      refer: 'breadcrumb.settings.root',
      current: 'breadcrumb.settings.affiliations'
    }
  }
})

export default routeAffiliationsConfig
